import { useState, useRef, useEffect } from 'react';
import { ReactComponent as ChevronDown } from 'icons/chevron-down.svg';

export default function Select({
  options = [],
  value = null,
  onChange,
  placeholder = 'Select an option',
  className = '',
}) {
  const [open, setOpen] = useState(false);
  const selectRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find((opt) => opt.id === value);

  return (
    <div className={`percentage-rules__select-container ${className}`} ref={selectRef}>
      <div className="percentage-rules__select-box" onClick={() => setOpen(!open)}>
        {selectedOption ? selectedOption.name : placeholder}
        <ChevronDown className={!open ? 'percentage-rules__arrow' : 'percentage-rules__arrow arrow-down'} />
      </div>

      {open && (
        <div className="percentage-rules__options-container show">
          {options.map((option) => (
            <div
              key={option.id}
              className="option"
              onClick={() => {
                onChange(option.id);
                setOpen(false);
              }}
            >
              {option.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
